<template>
    <div class="c-carousel">
        <span class="icon-close-btn" @click="callbackCloseStatus">X</span>
        <Carousel v-model="CarouselValue" loop :autoplay="CarouselSetting.autoplay"
            :autoplay-speed="CarouselSetting.autoplaySpeed" :dots="CarouselSetting.dots"
            :radius-dot="CarouselSetting.radiusDot" :trigger="CarouselSetting.trigger" :arrow="CarouselSetting.arrow">
            <CarouselItem>
                <div class="common-carousel-item">
                    <img src="../../assets/lb1.png" alt="">
                </div>
            </CarouselItem>
            <CarouselItem>
                <div class="common-carousel-item">
                    <img src="../../assets/lb2.png" alt="">
                </div>
            </CarouselItem>
            <CarouselItem>
                <div class="common-carousel-item">
                    <img src="../../assets/lb3.png" alt="">
                </div>
            </CarouselItem>
            <CarouselItem>
                <div class="common-carousel-item">
                    <img src="../../assets/lb4.png" alt="">
                </div>
            </CarouselItem>
            <CarouselItem>
                <div class="common-carousel-item">
                    <img src="../../assets/lb5.png" alt="">
                </div>
            </CarouselItem>
        </Carousel>
    </div>
</template>

<script>
    export default {
        name: 'CCarousel',
        props: {
            infoMsg: {
                type: String,
                default() {
                    return 'cmask'
                }
            }
        },
        data() {
            return {
                // 轮播图选中页
                CarouselValue: 0,
                // 轮播图参数配置
                CarouselSetting: {
                    autoplay: true,
                    autoplaySpeed: 8000,
                    dots: 'inside',
                    radiusDot: true,
                    trigger: 'click',
                    arrow: 'hover'
                }
            }
        },
        methods: {
            // 返回，向父组件CMask返回蒙版显隐状态
            callbackCloseStatus() {
                this.$emit("closeMask", false);
            }
        }
    }
</script>

<style scoped>
    .c-carousel {
        position: absolute;
        top: 56%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50%;
    }

    img {
        width: 100%;
    }

    .icon-close-btn {
        position: absolute;
        top: -2.2%;
        right: -1.6%;
        z-index: 1;
        width: 36px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 22px;
        color: #fff;
        background: rgba(182, 185, 186, 1) url(../../assets/close-c.png) 0 0 no-repeat;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        cursor: pointer;
    }
</style>